import React from 'react';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { ArrowLeft } from 'lucide-react';
import Footer from '../components/Footer';

const Datenschutz = () => {
  const navigateHome = () => {
    window.location.href = '/';
  };

  const sections = [
    {
      number: '1.',
      title: 'Verantwortlicher',
      content: (
        <div className="space-y-3">
          <p>Verantwortlich für die Datenverarbeitung auf dieser Website ist:</p>
          <div className="space-y-1">
            <p className="font-semibold">Cem Kilic</p>
            <p>Da Vinci Institut</p>
            <p>Quettinghofstraße 47c</p>
            <p>50769 Köln</p>
            <p>Deutschland</p>
            <p>E-Mail: <a href="mailto:info@davinci-institut.de" className="text-teal-600 hover:text-teal-800 transition-colors">info@davinci-institut.de</a></p>
            <p>Telefon: <a href="tel:+4915216817165" className="text-teal-600 hover:text-teal-800 transition-colors">+49 152 16817165</a></p>
          </div>
        </div>
      )
    },
    {
      number: '2.',
      title: 'Datenschutz auf einen Blick',
      content: (
        <div className="space-y-3">
          <p>Beim Besuch unserer Website werden personenbezogene Daten verarbeitet. Das betrifft einerseits Daten, die Sie uns aktiv mitteilen, etwa über das Kontaktformular. Andererseits werden beim Aufruf der Website automatisch technische Daten erfasst, damit die Seite sicher und fehlerfrei bereitgestellt werden kann.</p>
          <p>Personenbezogene Daten sind alle Daten, mit denen Sie direkt oder indirekt identifiziert werden können.</p>
        </div>
      )
    },
    {
      number: '3.',
      title: 'Hosting',
      content: (
        <div className="space-y-3">
          <p>Unsere Website wird über Emergent AI gehostet. Beim Aufruf der Website verarbeitet der Hosting-Anbieter technische Daten, die für die Bereitstellung und den sicheren Betrieb der Website erforderlich sind. Dazu können insbesondere IP-Adresse, Datum und Uhrzeit des Zugriffs, Browserinformationen, Betriebssystem, Referrer-URL und aufgerufene Inhalte gehören.</p>
          <p>Der Einsatz von Emergent AI erfolgt zur sicheren und zuverlässigen Bereitstellung unserer Website. Soweit eine Einwilligung für bestimmte Funktionen erforderlich ist, erfolgt die Verarbeitung auf Grundlage Ihrer Einwilligung.</p>
          <p>Sofern erforderlich, besteht ein Vertrag über Auftragsverarbeitung gemäß Art. 28 DSGVO.</p>
        </div>
      )
    },
    {
      number: '4.',
      title: 'Server-Logfiles',
      content: (
        <div className="space-y-3">
          <p>Beim Besuch unserer Website werden durch den Server automatisch Informationen erfasst und in sogenannten Server-Logfiles gespeichert. Dazu können gehören:</p>
          <ul className="list-disc pl-6 space-y-1">
            <li>IP-Adresse,</li>
            <li>Datum und Uhrzeit des Zugriffs,</li>
            <li>Browsertyp und Browserversion,</li>
            <li>verwendetes Betriebssystem,</li>
            <li>Referrer-URL,</li>
            <li>aufgerufene Seiten,</li>
            <li>anfragender Provider.</li>
          </ul>
          <p>Diese Daten werden verwendet, um die Website technisch bereitzustellen, Fehler zu erkennen und die Sicherheit zu gewährleisten.</p>
        </div>
      )
    },
    {
      number: '5.',
      title: 'Kontaktformular',
      content: (
        <div className="space-y-3">
          <p>Wenn Sie uns über das Kontaktformular kontaktieren, werden die von Ihnen eingegebenen Daten an uns übermittelt und gespeichert, damit wir Ihre Anfrage bearbeiten können. Je nach Formular können dies insbesondere Name, E-Mail-Adresse, Telefonnummer, gewünschtes Fach und Ihre Nachricht sein.</p>
          <p>Die Verarbeitung dieser Daten erfolgt ausschließlich zur Bearbeitung Ihrer Anfrage und gegebenenfalls zur Anbahnung oder Durchführung eines Vertragsverhältnisses. Eine Weitergabe an Dritte erfolgt nicht ohne Ihre Einwilligung, sofern keine gesetzliche Verpflichtung besteht.</p>
        </div>
      )
    },
    {
      number: '6.',
      title: 'WhatsApp-Kontakt',
      content: (
        <div className="space-y-3">
          <p>Auf unserer Website befindet sich ein Button, über den Sie zu WhatsApp weitergeleitet werden können. Wenn Sie diesen Button nutzen, werden Sie zu WhatsApp bzw. dem jeweiligen Anbieter weitergeleitet.</p>
          <p>Dabei kann der Anbieter personenbezogene Daten erhalten, insbesondere technische Verbindungsdaten sowie die Information, dass Sie unsere Website besucht und den WhatsApp-Link betätigt haben. Je nach Nutzung können weitere Daten übermittelt werden.</p>
          <p>Bitte übermitteln Sie über WhatsApp keine sensiblen Informationen, wenn Sie dies nicht ausdrücklich wünschen. Für datenschutzrechtlich sichere Anfragen empfehlen wir unser Kontaktformular oder eine Kontaktaufnahme per E-Mail.</p>
        </div>
      )
    },
    {
      number: '7.',
      title: 'Cookies',
      content: (
        <div className="space-y-3">
          <p>Unsere Website verwendet Cookies. Cookies sind kleine Textdateien, die auf Ihrem Endgerät gespeichert werden. Sie können technisch notwendig sein, um grundlegende Funktionen der Website zu ermöglichen. Andere Cookies können dazu dienen, die Nutzung der Website komfortabler zu machen oder bestimmte Funktionen bereitzustellen.</p>
          <p>Technisch notwendige Cookies werden eingesetzt, um die Website funktionsfähig zu halten. Soweit darüber hinaus optionale Cookies verwendet werden, erfolgt dies nur mit Ihrer Einwilligung.</p>
          <p>Sie können Ihren Browser so einstellen, dass Sie über das Setzen von Cookies informiert werden, Cookies nur im Einzelfall erlauben oder generell ausschließen. Bei der Deaktivierung von Cookies kann die Funktionalität der Website eingeschränkt sein.</p>
        </div>
      )
    },
    {
      number: '8.',
      title: 'Rechtsgrundlagen der Verarbeitung',
      content: (
        <div className="space-y-3">
          <p>Wir verarbeiten personenbezogene Daten je nach Zweck auf folgenden Rechtsgrundlagen:</p>
          <ul className="list-disc pl-6 space-y-2">
            <li>Art. 6 Abs. 1 lit. b DSGVO, wenn die Verarbeitung zur Vertragserfüllung oder zur Durchführung vorvertraglicher Maßnahmen erforderlich ist.</li>
            <li>Art. 6 Abs. 1 lit. f DSGVO, wenn ein berechtigtes Interesse an einer sicheren und funktionsfähigen Website besteht.</li>
            <li>Art. 6 Abs. 1 lit. a DSGVO, wenn Sie in eine Verarbeitung eingewilligt haben.</li>
          </ul>
        </div>
      )
    },
    {
      number: '9.',
      title: 'Speicherdauer',
      content: 'Wir speichern personenbezogene Daten nur so lange, wie dies für den jeweiligen Zweck erforderlich ist oder gesetzliche Aufbewahrungspflichten bestehen. Daten aus Kontaktanfragen werden gelöscht, sobald die Anfrage abschließend bearbeitet wurde und keine gesetzlichen Pflichten einer Löschung entgegenstehen.'
    },
    {
      number: '10.',
      title: 'Weitergabe von Daten',
      content: 'Eine Weitergabe personenbezogener Daten an Dritte erfolgt nur, soweit dies zur Bearbeitung Ihrer Anfrage, zur Vertragserfüllung, aufgrund einer gesetzlichen Verpflichtung oder mit Ihrer Einwilligung erforderlich ist.'
    },
    {
      number: '11.',
      title: 'Drittlandübermittlung',
      content: 'Soweit bei der Nutzung von Diensten, insbesondere bei Kommunikationsdiensten wie WhatsApp, eine Übermittlung personenbezogener Daten in Drittstaaten außerhalb der Europäischen Union nicht ausgeschlossen werden kann, kann es zu einer Verarbeitung außerhalb der EU kommen. In solchen Fällen kann kein mit der EU vergleichbares Datenschutzniveau garantiert werden.'
    },
    {
      number: '12.',
      title: 'Ihre Rechte',
      content: (
        <div className="space-y-3">
          <p>Sie haben im Rahmen der geltenden gesetzlichen Bestimmungen jederzeit das Recht auf:</p>
          <ul className="list-disc pl-6 space-y-1">
            <li>Auskunft über Ihre gespeicherten Daten,</li>
            <li>Berichtigung unrichtiger Daten,</li>
            <li>Löschung,</li>
            <li>Einschränkung der Verarbeitung,</li>
            <li>Widerspruch gegen die Verarbeitung,</li>
            <li>Datenübertragbarkeit,</li>
            <li>Widerruf erteilter Einwilligungen mit Wirkung für die Zukunft,</li>
            <li>Beschwerde bei einer Datenschutzaufsichtsbehörde.</li>
          </ul>
        </div>
      )
    },
    {
      number: '13.',
      title: 'SSL-/TLS-Verschlüsselung',
      content: 'Diese Website nutzt aus Sicherheitsgründen und zum Schutz vertraulicher Inhalte eine SSL- bzw. TLS-Verschlüsselung. Eine verschlüsselte Verbindung erkennen Sie daran, dass die Adresszeile des Browsers mit „https://" beginnt.'
    },
    {
      number: '14.',
      title: 'Änderung dieser Datenschutzerklärung',
      content: 'Wir behalten uns vor, diese Datenschutzerklärung anzupassen, wenn sich rechtliche Vorgaben, unsere Website oder die eingesetzten Dienste ändern.'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-white shadow-md sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex items-center justify-between">
            <img 
              src="/images/davinci-logo-new.png" 
              alt="Da Vinci Institut" 
              className="h-16 md:h-24 cursor-pointer"
              onClick={navigateHome}
            />
            <Button
              onClick={navigateHome}
              variant="outline"
              className="border-2 border-teal-600 text-teal-600 hover:bg-teal-50 rounded-full"
            >
              <ArrowLeft className="w-4 h-4 mr-2" />
              Zurück zur Startseite
            </Button>
          </div>
        </div>
      </header>

      {/* Content */}
      <section className="py-16 md:py-20 bg-gradient-to-br from-teal-50 via-white to-teal-50/30 relative">
        <div className="absolute top-20 left-0 w-72 h-72 bg-teal-100/40 rounded-full blur-3xl -translate-x-1/2"></div>
        <div className="absolute top-32 right-0 w-96 h-96 bg-teal-200/30 rounded-full blur-3xl translate-x-1/3"></div>
        
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-8 text-center">
            Datenschutzerklärung
          </h1>
          
          <Card className="border-gray-200 shadow-xl rounded-3xl overflow-hidden">
            <CardContent className="p-8 md:p-12 space-y-8">
              {sections.map((section, index) => (
                <div key={index}>
                  <h2 className="text-2xl font-bold text-teal-700 mb-4">
                    {section.number} {section.title}
                  </h2>
                  <div className="text-gray-700 leading-relaxed">
                    {section.content}
                  </div>
                </div>
              ))}
            </CardContent>
          </Card>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Datenschutz;
